import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import PropertiesView from "../views/PropertiesView.vue";
import PropertyDetailView from "../views/PropertyDetailView.vue";
import { getPropertyById } from "@/data/properties";
import { getAreaBySlug } from "@/data/areas";
import { getBlogBySlug } from "@/data/blog";

const SITE = "عقارات الكويت";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
    meta: { title: `الرئيسية — ${SITE}` },
  },
  {
    path: "/properties",
    name: "properties",
    component: PropertiesView,
    meta: { title: `العقارات — ${SITE}` },
  },
  {
    path: "/properties/:id",
    name: "property-detail",
    component: PropertyDetailView,
    meta: { title: `تفاصيل العقار — ${SITE}` },
  },
  {
    path: "/areas",
    name: "areas",
    component: () =>
      import(/* webpackChunkName: "areas" */ "../views/AreasView.vue"),
    meta: { title: `المناطق — ${SITE}` },
  },
  {
    path: "/areas/:slug",
    name: "area-detail",
    component: () =>
      import(/* webpackChunkName: "areas" */ "../views/AreaDetailView.vue"),
    meta: { title: `المنطقة — ${SITE}` },
  },
  {
    path: "/services",
    name: "services",
    component: () =>
      import(/* webpackChunkName: "services" */ "../views/ServicesView.vue"),
    meta: { title: `خدماتنا — ${SITE}` },
  },
  {
    path: "/contact",
    name: "contact",
    component: () =>
      import(/* webpackChunkName: "contact" */ "../views/ContactView.vue"),
    meta: { title: `تواصل معنا — ${SITE}` },
  },
  {
    path: "/faq",
    name: "faq",
    component: () =>
      import(/* webpackChunkName: "faq" */ "../views/FaqView.vue"),
    meta: { title: `الأسئلة الشائعة — ${SITE}` },
  },
  {
    path: "/blog",
    name: "blog",
    component: () =>
      import(/* webpackChunkName: "blog" */ "../views/BlogView.vue"),
    meta: { title: `المدونة — ${SITE}` },
  },
  {
    path: "/blog/:slug",
    name: "blog-detail",
    component: () =>
      import(/* webpackChunkName: "blog" */ "../views/BlogDetailView.vue"),
    meta: { title: `المقال — ${SITE}` },
  },
  {
    path: "/about",
    name: "about",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
    meta: { title: `من نحن — ${SITE}` },
  },
  {
    path: "/:pathMatch(.*)*",
    name: "not-found",
    component: () =>
      import(/* webpackChunkName: "not-found" */ "../views/NotFoundView.vue"),
    meta: { title: `صفحة غير موجودة — ${SITE}` },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 };
  },
});

function resolveTitle(to) {
  if (to.name === "property-detail") {
    const p = getPropertyById(to.params.id);
    if (p) return `${p.title} — ${SITE}`;
  }
  if (to.name === "area-detail") {
    const a = getAreaBySlug(to.params.slug);
    if (a) return `${a.name} — ${SITE}`;
  }
  if (to.name === "blog-detail") {
    const b = getBlogBySlug(to.params.slug);
    if (b) return `${b.title} — ${SITE}`;
  }
  return to.meta.title || SITE;
}

router.afterEach((to) => {
  document.title = resolveTitle(to);
});

export default router;
